import useEventEmitter from './useEventEmitter';

/**
 * Type for chart event symbols.
 *
 * @public
 */

/**
 * Creates a typed chart event symbol given a unique identifier.
 *
 * @typeParam T - Data carried by the event.
 * @typeParam E - Event type or types associated with the event.
 * @param uniqueKey - Unique key to identify this chart event.
 * @returns A symbol representing the event.
 *
 * @public
 */
export function createChartEvent(uniqueKey) {
  return Symbol(uniqueKey);
}

/**
 * Returns a function to emit the specified event, allowing for optional event filtering
 * and an optional callback to receive event data.
 * ```ts
 *  # Listen to all events
 *  useChartEvents('tooltip', callback),
 *
 *  # No callback just listen
 *  const {emit} = useChartEvents('tooltip', ['pointermove']),
 *
 *  # Callback and
 *  const {emit} = useChartEvents('tooltip', ['pointermove'], callback ),
 * ```
 *
 * @typeParam T - The type of the chart event symbol.
 * @param chartEventType - Event symbol to subscribe and emit.
 * @param eventFilter - Specific event type(s) to filter the emitted event.
 * @param callback - Optional callback invoked with event data.
 * @returns An object containing the emit function.
 *
 * @public
 */

/** @public */

/** @public */

/** @public */

/** @public */
export function useChartEvents(chartEventType, arg1, callback) {
  if (typeof arg1 === 'function') {
    return {
      emit: useEventEmitter(chartEventType, undefined, d => arg1 && arg1(d))
    };
  }
  return {
    emit: useEventEmitter(chartEventType, arg1, callback)
  };
}